import { YStack } from 'tamagui';

import { GoalSetSection } from '../../components/cards/GoalSetSection';
import { H6Emphasized } from '../../components/text/Typography';

export const GoalSetSections = () => {
    return (
        <YStack gap={24} maxWidth={420} width="100%">
            <H6Emphasized>Single item</H6Emphasized>
            <GoalSetSection
                number={1}
                title="1 month emergency fund"
                items={[
                    {
                        label: '1 month emergency fund',
                        emphasizedText: 'Target: $3,060',
                        rightText: 'Aug 2026',
                    },
                ]}
            />

            <H6Emphasized>Multiple items</H6Emphasized>
            <GoalSetSection
                number={2}
                title="Financial health"
                items={[
                    {
                        label: 'Pay off debt (80%)',
                        emphasizedText: 'Total debt: $3,573',
                        rightText: 'Mar 2028',
                    },
                    {
                        label: 'Full emergency fund (15%)',
                        emphasizedText: 'Target: $16,200',
                        rightText: 'Apr 2030',
                    },
                    {
                        label: 'Retirement – Roth IRA (5%)',
                        emphasizedText: 'Target: $7,500/yr',
                        rightText: 'Jul 2030',
                    },
                ]}
            />

            <H6Emphasized>Item without label</H6Emphasized>
            <GoalSetSection
                number={3}
                title="Savings goals"
                items={[
                    {
                        label: 'Save for something',
                        emphasizedText: '$5,400',
                        rightText: 'Funded by...',
                    },
                ]}
            />

            <H6Emphasized>Custom accent color</H6Emphasized>
            <GoalSetSection
                number={4}
                title="Long term"
                accentColor="$leaf"
                items={[
                    {
                        label: 'Down payment',
                        emphasizedText: 'Target: $40,000',
                        rightText: 'Dec 2031',
                    },
                    {
                        label: 'Travel fund',
                        emphasizedText: 'Target: $8,000',
                        rightText: 'Jun 2027',
                    },
                ]}
            />
        </YStack>
    );
};
